"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONE_TIME_PRICE = exports.YEARLY_PRICE = exports.MONTHLY_PRICE = exports.PRICE = exports.OVERALL_RATING = exports.RELEVANCE = exports.RANDOM = exports.NAME = exports.FIRST_PUBLISHED = exports.HUB_INSTALLS = void 0;
var HUB_INSTALLS = 'HUB_INSTALLS';
exports.HUB_INSTALLS = HUB_INSTALLS;
var FIRST_PUBLISHED = 'FIRST_PUBLISHED';
exports.FIRST_PUBLISHED = FIRST_PUBLISHED;
var NAME = 'NAME';
exports.NAME = NAME;
var RANDOM = 'RANDOM';
exports.RANDOM = RANDOM;
var RELEVANCE = 'RELEVANCE';
exports.RELEVANCE = RELEVANCE;
var OVERALL_RATING = 'OVERALL_RATING'; // This is just for convenience. Always send appropriate sort field for selected plan type.

exports.OVERALL_RATING = OVERALL_RATING;
var PRICE = 'PRICE';
exports.PRICE = PRICE;
var MONTHLY_PRICE = 'MONTHLY_PRICE';
exports.MONTHLY_PRICE = MONTHLY_PRICE;
var YEARLY_PRICE = 'YEARLY_PRICE';
exports.YEARLY_PRICE = YEARLY_PRICE;
var ONE_TIME_PRICE = 'ONE_TIME_PRICE';
exports.ONE_TIME_PRICE = ONE_TIME_PRICE;


//////////////////
// WEBPACK FOOTER
// ./js/constants/search/SortField.js
// module id = 140
// module chunks = 209 210 211 212 213